<!--  -->
<template>
  <div style="height: 850px;overflow-y: auto;">
    <div v-if="presentation_type == 1" class="phone" style="margin-top:1vw;">
      <h3>📱 手机界面预览</h3>
      <!-- 预览外层容器：固定小尺寸 -->
      <div class="mobile-preview-wrapper">
        <!-- 内层手机框架，按比例缩放 -->
        <div class="phone-frame">
          <div
            class="screen"
            :style="{ backgroundImage: `url(${background_image || 'http://zyc-dev.jingxuanhz.com/dj/img/operation/newlyinmessage/operationPMANV202505101746865004735.png'})` }"
          >
            <div
              v-if="pop_up_image"
              class="pop-bg"
              :style="{
                backgroundImage: `url(${pop_up_image})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
              }"
            />
            <div class="pop-content">
              <!-- 弹窗标题 -->
              <div class="popup-title">
                {{ button_title_text }}
              </div>
              <!-- 弹窗简介 -->
              <div class="popup-description">
                {{ button_introduction_text }}
              </div>
              <div
                v-if="button_text"
                class="preview-button"
              >
                <img
                  v-if="guide_map"
                  :src="guide_map"
                  class="btn-icon"
                >
                {{ button_text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-form
      label-position="right"
      :model="form"
      style="position:relative"
    >
      <el-form-item label="标题">
        <el-input
          v-model="title"
          placeholder="请输入标题"
          style="width:400px;margin-right:10px"
        />
      </el-form-item>
      <el-form-item label="类型">
        <el-radio-group v-model="presentation_type" @change="onPresentationTypeChange">
          <el-radio-button :label="1">默认</el-radio-button>
          <el-radio-button :label="3">官方阅读器模式</el-radio-button>
          <el-radio-button :label="4">文章</el-radio-button>
        </el-radio-group>
        <div v-if="presentation_type == 4" class="title-tips">(不具备阅读器权限才适用文章类型)</div>
      </el-form-item>

      <el-form-item label="背景颜色">
        <el-color-picker v-model="background_color" />
      </el-form-item>
      <el-form-item label="广告来源">
        <el-switch
          v-model="advertising_source"
          active-color="#13ce66"
          inactive-color="rgb(191,191,191)"
          active-text="开启验证"
          inactive-text="关闭验证"
          :active-value="1"
          :inactive-value="2"
          @change="stopr($event,scope.row)"
        />
      </el-form-item>
      <!-- <el-form-item>
        <el-button
          v-show="presentation_type == 2"
          type="primary"
          size="mini"
          @click="chaweimg"
        >插入图片到内容</el-button>
        <el-button
          v-show="presentation_type == 2"
          type="primary"
          size="mini"
          @click="searchr"
        >插入企微二维码</el-button>
      </el-form-item>
      <el-form-item
        v-show="presentation_type == 2"
        label="B页"
      >
        <br>
        <Editor-wang
          ref="editorwangfour"
          v-model="novel_content"
        />
      </el-form-item> -->

      <el-form-item label="小程序">
        <div>
          <el-tag
            v-if="wechatid"
            style="margin-right:10px"
          >{{ wechatname }}</el-tag>
          <el-button
            v-if="alltype == 1 || alltype == 3"
            type="primary"
            size="mini"
            @click="choosewecaht"
          >选择小程序</el-button>
        </div>
      </el-form-item>
      <el-form-item
        v-if="presentation_type == 3"
        label="官方阅读指定小说"
      >
        <el-tag v-if="official_novel_no!=''" style="margin-right: 10px;">{{ official_novel_no_name }} ({{ official_novel_no }})</el-tag>
        <el-button type="primary" size="mini" :disabled="!wechatid" @click="choosenocelr(2)">选择官方阅读指定小说</el-button>
      </el-form-item>
      <el-form-item
        label="屏蔽方式"
      >
        <el-radio-group v-model="shield_type" @change="nkawer">
          <el-radio-button v-if="presentation_type != 4" :label="1">小说</el-radio-button>
          <el-radio-button v-if="presentation_type != 4" :label="2">提示系统错误</el-radio-button>
          <el-radio-button v-if="presentation_type == 4" :label="4">文章</el-radio-button>
          <!-- <el-radio-button :label="3">提示A页面</el-radio-button> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="presentation_type == 4"
        label="屏蔽时指定文章"
      >
        <el-tag v-if="applet_article_id!=''" style="margin-right: 10px;">{{ applet_article_name }} ({{ applet_article_id }})</el-tag>
        <el-button type="primary" size="mini" :disabled="!wechatid" @click="chooseOfficialArticle">选择官方阅读指定文章</el-button>
      </el-form-item>
      <el-form-item label="屏蔽城市">
        <div class="linkfw">
          <el-tree
            ref="tree"
            :data="address"
            show-checkbox
            node-key="label"
            highlight-current
            :props="defaultProps"
            :check-on-click-node="true"
            @check-change="handleCheckChange"
          />
        </div>
      </el-form-item>
      <el-form-item
        label="屏蔽时间"
      >
        <el-time-picker
          v-model="timevalue"
          is-range
          range-separator="至"
          format="HH:mm"
          value-format="HH:mm"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          @change="clearTime"
        />
      </el-form-item>
      <el-form-item
        v-if="shield_type == 1"
        label="小说"
      >
        <el-tag v-if="novel_no!=''" style="margin-right: 10px;">{{ novel_name }} ({{ novel_no }})</el-tag>
        <el-button type="primary" size="mini" :disabled="!wechatid" @click="choosenocelr(1)">选择小说</el-button>
      </el-form-item>
      <el-form-item
        v-if="shield_type == 4"
        label="B页面内容"
        style="margin-top:100px"
      >
        <br>
        <Editor-wang
          ref="editorwangfour"
          v-model="novel_content"
        />
      </el-form-item>
      <el-form-item
        v-if="shield_type == 3"
        label="A页"
        style="margin-top:100px"
      >
        <br>
        <Editor-wang
          ref="editorwangfourinr"
          v-model="novel_content_a"
        />
      </el-form-item>
      <!-- <el-form-item
        v-show="presentation_type == 2"
        label="A页"
      >
        <el-tag v-if="article_id!=''" type="success" style="margin-right:10px">{{ article_name }}</el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="activewe"
        >选择A页</el-button>
      </el-form-item> -->
      <el-form-item
        label="底部按钮图"
        style="position:relative"
      >
        <div>
          <img
            v-if="novel_button_img"
            style="height: 120px; width: 120px;"
            :src="novel_button_img"
          >
        </div>
        <el-button
          type="primary"
          size="mini"
          @click="aweq('novel_button_img')"
        >素材库选择/上传</el-button>
        <!-- <el-button
          v-if="background_image"
          type="warning"
          size="mini"
          style="margin-left:10px;"
          @click="clearImage('background_image')"
        >
          清除
        </el-button> -->
      </el-form-item>
      <el-form-item label="按钮图显示(秒)">
        <el-input-number v-model="button_display_time" :min="0" label="按钮在几秒显示(秒)" />
      </el-form-item>
      <!-- <el-form-item label="发送内容">
        <el-input
          v-model="send_text"
          placeholder="请输入内容"
          @blur="handleInputBlur"
          style="width:400px;margin-right:10px"
        />
        <el-link
          type="primary"
          @click="addidentifit"
        >添加获客链接</el-link>
      </el-form-item> -->
      <el-form-item v-if="presentation_type == 1" label="按钮文字">
        <el-input
          v-model="button_text"
          placeholder="请输入按钮文字"
          style="width:400px"
          maxlength="5"
        />
      </el-form-item>
      <el-form-item v-if="presentation_type == 1" label="按钮标题">
        <el-input
          v-model="button_title_text"
          placeholder="请输入按钮标题"
          style="width:400px"
          maxlength="7"
        />
      </el-form-item>
      <el-form-item v-if="presentation_type == 1" label="按钮简介">
        <el-input
          v-model="button_introduction_text"
          placeholder="请输入按钮简介"
          style="width:400px"
          maxlength="20"
        />
      </el-form-item>
      <el-form-item
        v-if="presentation_type == 1"
        label="弹窗背景图"
        style="position:relative"
      >
        <div>
          <div class="warning-title">*推荐尺寸:w-294px h-340px</div>
          <el-button
            type="primary"
            size="mini"
            @click="aweq('pop_up_image')"
          >素材库选择/上传</el-button>
          <el-button
            v-if="pop_up_image"
            type="warning"
            size="mini"
            style="margin-left:10px;"
            @click="clearImage('pop_up_image')"
          >
            清除
          </el-button>
        </div>
      </el-form-item>
      <el-form-item
        v-if="presentation_type == 1"
        label="按钮左侧图"
        style="position:relative"
      >
        <div class="warning-title">
          *推荐尺寸:w-27.3px h-27.3px
        </div>
        <el-button
          type="primary"
          size="mini"
          @click="aweq('guide_map')"
        >素材库选择/上传</el-button>
        <el-button
          v-if="guide_map"
          type="warning"
          size="mini"
          style="margin-left:10px;"
          @click="clearImage('guide_map')"
        >
          清除
        </el-button>
      </el-form-item>
      <el-form-item
        v-if="presentation_type == 1"
        label="背景图"
        style="position:relative"
      >
        <div class="warning-title">
          <span>*推荐尺寸:w-375px h-736px</span>
          <span style="margin-left:10px">*默认是灰色透明背景图</span>
        </div>
        <el-button
          type="primary"
          size="mini"
          @click="aweq('background_image')"
        >素材库选择/上传</el-button>
        <el-button
          v-if="background_image"
          type="warning"
          size="mini"
          style="margin-left:10px;"
          @click="clearImage('background_image')"
        >
          清除
        </el-button>
      </el-form-item>
      <!-- <el-form-item label="企业">
        <el-tag
          v-if="form.corp_id!=''"
          style="margin-right:10px"
        >{{ name }} ({{ form.corp_id }}) </el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="choose"
        >选择企业</el-button>
      </el-form-item>
      <el-form-item label="企业员工">
        <el-tag
          v-for="items,index in form.userids"
          :key="index"
          style="margin-right:10px"
          closable
          @close="handleClose(index)"
        >{{ items.name }} </el-tag>
        <el-button
          :disabled="form.corp_id===''"
          type="primary"
          size="mini"
          @click="chorwe"
        >选择企业员工</el-button>
      </el-form-item> -->
      <!-- <el-form-item label="发送次数">
        <el-input-number
          v-model="send_number"
          :min="0"
          label="请输入发送次数"
        /><span class="warning-title">*0代表无限</span>
      </el-form-item>
      <el-form-item label="超时时间">
        <el-input-number
          v-model="extend_seconds"
          :min="0"
          :step="1"
          :precision="0"
          label="请输入发送次数"
        /><span class="warning-title">(单位秒)*0代表无限</span>
      </el-form-item> -->
      <el-form-item label="回复内容">
        <el-tabs v-model="activeName">
          <el-tab-pane
            v-for="item,index in tabarr"
            :key="index"
            :label="item.value"
            :name="item.key"
          >
            <div v-if="item.key === 'text'">
              <el-input
                v-model="obj.content"
                type="textarea"
                :rows="8"
                placeholder="请输入内容"
                @blur="handleInputBlur"
              />

              <div style="margin-top:20px">
                <span>*未选择员工时，不要填写获客链接*</span><br>
                <el-link
                  type="primary"
                  @click="xuanhfive('text')"
                >选择二级跳转</el-link>
                <!-- <el-link
                  :disabled="form.userids.length === 0"
                  type="primary"
                  @click="addidentifit"
                >添加获客链接</el-link> -->
                <!-- <el-link
                  style="margin-left: 10px;"
                  type="primary"
                  @click="addidentifitindex"
                >添加返回首页</el-link> -->
              </div>
            </div>
            <div v-if="item.key === 'img'">
              <img
                v-if="temporary"
                class="pic_img"
                :src="temporary"
              >
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="materiallibrary"
                > {{ temporary === null ? '素材库选择/上传' : '素材库修改/上传' }}</el-button>
              </div>
            </div>
            <div v-if="item.key === 'news'" class="allexamples_box_top">
              <div class="allexamples_box">
                <div
                  v-if="arr.length === 1"
                  class="examples_leftbox"
                >
                  <div class="within_box">
                    <div class="title_boxr">{{ arr[0].title }}</div>
                    <div class="imaetext se_top">
                      <div
                        class="describe_text"
                        style="width:156px"
                      >{{ arr[0].description }}</div>
                      <div>
                        <img
                          v-if="arr[0].testsrc"
                          style="width:50px;height:50px;object-fit: contain;"
                          :src="arr[0].testsrc"
                        >
                      </div>
                    </div>
                  </div>
                  <!-- <div class="addwr" @click="addImageText">+新建消息</div> -->
                </div>
                <!-- <div v-else style="margin-right:20px">
                  <div v-for="items,indexr in arr" :key="indexr" :class="[items.id===active?'updataactive':'',indexr === 0 ? 'updatabox' : 'updatabox1']" @click.stop="activeclick(items.id,indexr)">
                    <span :class="[indexr === 0?'spanbox':'spanbox1']">
                      {{ items.title }}
                    </span>
                    <div :style="{backgroundImage: 'url('+items.testsrc+')'}" :class="[indexr === 0?'backrbox':'backrbox1']" />
                    <div v-show="items.showtips && indexr !== 0" class="ciclebox">
                      <div class="tiparrowbox">
                        <i v-show="indexr !== 0" class="el-icon-delete tipicon" @click.stop="deleteitem(indexr)" />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="arr.length<8"
                    class="addbox"
                  >
                    <span @click="addImageText">+新建消息</span>
                  </div>
                </div> -->

                <div class="examples_rightbox">
                  <div class="input_box">
                    <div>标题：</div>
                    <div><el-input
                      v-model="arr[indexinput].title"
                      maxlength="50"
                      style="width:420px"
                      placeholder="请输入标题"
                    /></div>
                  </div>

                  <div class="input_box">
                    <div>链接：</div>
                    <div><el-input
                      v-model="arr[indexinput].url"
                      style="width:350px"
                      placeholder="请输入链接"
                      @blur="tiaoInputBlur"
                    /></div>
                    <div>
                      <el-link
                        :disabled="form.userids.length === 0"
                        type="primary"
                        style="margin-left:10px"
                        @click="addidentifittwo"
                      >添加获客链接</el-link>
                      <el-link
                        type="primary"
                        style="margin-left:10px"
                        @click="xuanhfive('news')"
                      >选择二级跳转</el-link>
                      <!-- <el-link
                        style="margin-left: 10px;"
                        type="primary"
                        @click="addidentifittwoindex"
                      >添加返回首页</el-link> -->
                    </div>
                  </div>
                  <div class="input_box">
                    <div>描述：</div>
                    <div><el-input
                      v-model="arr[indexinput].description"
                      maxlength="50"
                      style="width:300px"
                      type="textarea"
                      placeholder="请输入描述"
                    /></div>
                  </div>
                  <div class="cover_box">
                    <div>封面：</div>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="materiallibrary"
                    >{{ arr[indexinput].testsrc === '' ? '素材库选择/上传' : '素材库修改/上传' }}</el-button>
                  </div>
                  <div style="color:red;margin-top:10px">*图片链接，支持JPG、PNG格式，较好的效果为大图360*200，小图200*200</div>
                  <img
                    v-if="arr[indexinput].testsrc"
                    :src="arr[indexinput].testsrc"
                    class="uopatatextimg"
                  >

                </div>
              </div>
            </div>
            <div v-if="item.key == 'miniprogrampage'">
              <div style="margin-top:10px">
                <el-form
                  label-width="70px"
                  :label-position="labelPosition"
                  :model="formLabelAlign"
                >
                  <el-form-item label="标题" style="margin-bottom: 18px;">
                    <el-input
                      v-model="formLabelAlign.name"
                      style="width:300px"
                    />
                  </el-form-item>
                  <el-form-item label="上传封面" style="margin-bottom: 18px;">
                    <div>
                      <img
                        v-if="programimg"
                        class="li_img"
                        :src="programimg"
                      >
                    </div>
                    <el-button
                      type="primary"
                      size="mini"
                      @click="materiallibrary"
                    >素材库选择/上传</el-button>
                  </el-form-item>
                  <!-- <el-form-item label="小程序APPID">

                    <el-input
                      v-model="formLabelAlign.appid"
                      style="width:200px"
                    />
                  </el-form-item> -->

                  <el-form-item label="跳转地址" style="margin-bottom: 10px;">
                    <!-- <el-input
                      v-model="formLabelAlign.link"
                      style="width:300px"
                    /> -->
                    <el-select v-model="formLabelAlign.link" placeholder="请选择跳转地址">
                      <el-option
                        v-for="itemr in options"
                        :key="itemr.value"
                        :label="itemr.label"
                        :value="itemr.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <!-- <el-form-item label="客服自定义回复">
        <div><el-input
          v-model="right_content"
          style="width:300px"
          placeholder="请输入右侧客服自定义回复"
        /></div>
      </el-form-item>
      <el-form-item label="客服按钮">
        <el-radio-group v-model="display">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="2">隐藏</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="是否开启捕捉异常浏览">
        <el-radio-group v-model="is_browsing">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="is_browsing == 1"
        label="推广链接异常浏览默认时间"
      >
        <el-input-number
          v-model="browsing_at"
          :min="0"
          :precision="0"
          :step="1"
          label="推广链接异常浏览默认时间（秒）"
        /><span class="warning-title">(单位：秒) <i style="margin-left: 20px;" class="el-icon-info" /> 用于判断用户是否在短时间内快速滑动至内容底部，命中后将直接屏蔽用户</span>
      </el-form-item>
      <el-form-item v-if="presentation_type != 4" label="关联获客链接">
        <div>
          <el-tag
            v-for="(item, index) in linkedCustomerAcquisition"
            :key="index"
            style="margin-right:10px;margin-bottom:5px"
            closable
            @close="handleRemoveLink(index)"
          >{{ item.title }}</el-tag>
          <el-button
            type="primary"
            size="mini"
            :disabled="!wechatid"
            @click="openLinkDialog"
          >选择</el-button>
        </div>
      </el-form-item>
      <el-form-item
        v-if="presentation_type != 4"
        label="备用小说"
      >
        <div style="display: flex;align-items: center;">
          <el-button type="primary" size="mini" :disabled="!wechatid" @click="choosenocelrchart">选择备用小说</el-button>
          <el-tag v-if="backup_novel_no" style="margin-left: 10px;margin-right: 10px;">{{ backup_novel_name }} ({{ backup_novel_no }})</el-tag>
          <el-button v-if="backup_novel_no" type="text" size="mini" @click="clearBackupNovel">清除</el-button>
        </div>
        <div>
          推广连接小说被下架时，使用备用小说代替
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择企业"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <enterprise @callback="callbackr" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
    <el-dialog
      title="选择绑定的小程序"
      :visible.sync="dialogVisiblewechat"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="50%"
      @closed="onDialogClosed"
    >
      <chhosewechat
        ref="chhosewecahtr"
        @callback="callback"
      />
    </el-dialog>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletuww"
      width="50%"
      append-to-body
    >
      <TencentCloudChooseimgr
        ref="TencentCloudChooseimgrview"
        @clickicon="chuantu"
      />
    </el-dialog>
    <el-dialog
      title="选择图片"
      :visible.sync="choicedialogVisibleimg"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="30%"
    >
      <selectImage @callbackimgs="callbackimgs" />
    </el-dialog>
    <el-dialog
      title="选择文章"
      :visible.sync="dialogVisiblenotes"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="80%"
    >
      <chooseaciver
        ref="chooseaciverview"
        @wenzhang="wenzhang"
      />
    </el-dialog>
    <el-dialog
      title="选择二维码"
      :visible.sync="erweidialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="50%"
    >
      <erweima
        ref="erweimaview"
        @callbackerweima="callbackerweima"
      />
    </el-dialog>
    <el-dialog
      title="选择小说"
      :visible.sync="noveldialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="70%"
    >
      <novellistdialog
        ref="novellistdialogview"
        @callnovel="callnovel"
      />
    </el-dialog>
    <el-dialog
      title="关联获客链接"
      :visible.sync="linkDialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
      @close="handleLinkDialogClose"
    >
      <link-customer-acquisition
        ref="linkCustomerAcquisitionView"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="linkDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmLinkSelection">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="选择二级跳转链接"
      :visible.sync="hfivedialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="70%"
    >
      <hfive
        ref="hfiveview"
        @hfiveviewcallback="hfiveviewcallback"
      />
    </el-dialog>
    <el-dialog
      title="选择备用小说"
      :visible.sync="novelChartdialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="70%"
    >
      <novellistdialog
        ref="novelStandbyialogview"
        @callnovel="callnovel"
      />
    </el-dialog>
  </div>
</template>

<script>
import enterprise from '../../behavioralsource/components/enterprise.vue'
import bandstaff from './bandstaff.vue'
import { iqiyipromotionlinkcreate, iqiyipromotionlinkedit } from '@/api/officialaccount.js'
import chhosewechat from './chhosewechat.vue'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
import TencentCloudChooseimgr from '../components/TencentCloudChooseimg.vue'
import { city_data } from '@/utils/address.js'
import { normalizeMiniProgramHtml } from '@/utils/index.js'
import selectImage from '../../articlerecommendation/components/selectImage.vue'
import EditorWang from '../../accountPush/components/AboutView.vue'
import chooseaciver from './chooseaciver.vue'
import erweima from '../../aqiiservice/components/erweima.vue'
import novellistdialog from './novellistdialog.vue'
import linkCustomerAcquisition from './linkCustomerAcquisition.vue'
import hfive from './hfive.vue'
export default {
  components: { enterprise, bandstaff, chhosewechat, chooseimg, TencentCloudChooseimgr, selectImage, EditorWang, chooseaciver, erweima, novellistdialog, linkCustomerAcquisition, hfive },
  data() {
    return {
      novelChartdialog: false,
      backup_novel_no: '',
      backup_novel_name: '',
      dialogVisible: false,
      dialogVisibler: false,
      name: '',
      form: {
        corp_id: '',
        userids: [],
        type: 1
      },
      useridsall: [],
      addtifit: '{wx_url}',
      send_text: '',
      blurIndex: null, // 获取输入框索引值
      title: '',
      wechatid: null,
      wechatname: '',
      dialogVisiblewechat: false,
      button_text: '在线客服',
      button_title_text: '联系客服',
      button_introduction_text: '',
      dialogVisibletwo: false,
      activeName: 'text', // tab切换显示隐藏
      tabarr: [
        {
          key: 'text',
          value: '文本'
        },
        {
          key: 'img',
          value: '图片'
        },
        {
          key: 'news',
          value: '图文链接'
        },
        {
          key: 'miniprogrampage',
          value: '小程序消息'
        }
      ],
      obj: {
        content: ''
      },
      temporary: null, // 上传图片显示(不是图文图片)
      keyid: null, // 上传图片成功的key 不是图文 是图片消息
      arr: [
        {
          id: Math.random(), // id
          title: '标题',
          url: '',
          description: '',
          testsrc: '',
          showtips: false, // tip框的显示隐藏
          switchvalue: 2, // 1开 2关
          app_ids: '', // 小程序
          app_path: '', // 链接
          moswitchvalue: 1 // 1 默认 2 不默认（前端储存）
        }
      ],
      indexinput: 0, // 取出来的索引值
      tiaoblurIndex: null, // 获取输入框索引值
      // 小程序消息参数
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        sourceMaterialId: null,
        link: '',
        // appid: null,
        appid_Link: ''
      },
      programimg: null,
      msgData: {},
      alltype: null,
      editid: null,
      send_number: 0,
      extend_seconds: 0,
      background_image: '',
      pop_up_image: 'https://zyc.jingxuanhz.com/dj/img/operation/newlyinmessage/operationIWGWM202505101746859778246.png',
      guide_map: '',
      dialogVisibletuww: false,
      xuantype: null,
      selectedNodes: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      loadselect: false,
      address: city_data() || [],
      presentation_type: 1,
      novel_content: '',
      choicedialogVisibleimg: false,
      novel_button_img: '',
      article_id: '',
      article_name: '',
      ont: {},
      dialogVisiblenotes: false,
      erweidialog: false,
      background_color: '#F7F7F7',
      advertising_source: 1,
      right_content: '',
      display: 1,
      button_display_time: 20,
      novel_content_a: '',
      addtifitindex: '{home_url}',
      options: [{
        value: 'pages/index/index',
        label: 'pages/index/index'
      }],
      shield_type: 3,
      novel_no: '',
      novel_name: '',
      noveldialog: false,
      ids: null,
      timevalue: ['', ''], // 必须是数组，否则选不了
      linkDialogVisible: false, // 关联获客链接弹窗显示状态
      linkedCustomerAcquisition: [], // 已关联的获客链接 [{id, title}]
      paid: null,
      is_browsing: 1, // 是否开启捕捉异常浏览 1=开启，2=关闭，默认1
      browsing_at: 8, // 推广链接异常浏览默认时间（秒数），默认8秒
      xiaoshuotype: null,
      official_novel_no: '',
      official_novel_no_name: '',
      applet_article_id: '',
      applet_article_name: '',
      hfivedialog: false,
      // h5 占位符插入目标：text=文本回复框，news=图文链接输入框
      hfiveInsertTarget: 'news'
    }
  },
  created() {},
  mounted() {},
  methods: {
    choosenocelrchart() {
      // eslint-disable-next-line eqeqeq
      if (this.wechatid == '' || this.wechatid == null) {
        this.$message.error('请选择小程序')
        return
      }
      this.xiaoshuotype = 3
      this.novelChartdialog = true
      this.$nextTick(() => {
        this.$refs.novelStandbyialogview.sendr(this.wechatid, this.xiaoshuotype)
      })
    },
    clearBackupNovel() {
      this.backup_novel_no = ''
      this.backup_novel_name = ''
    },
    logAppidsLengthDisabled() {
      const len = Array.isArray(this.wechatid) ? this.wechatid.length : 0
      console.log('wechatid.length:', len)
      return !len
    },
    send(alltype, item) {
      this.alltype = alltype
      // eslint-disable-next-line eqeqeq
      if (alltype == 2) {
        this.paid = item.id
      }
      console.log(alltype)
      // eslint-disable-next-line eqeqeq
      if (alltype == 1) {
        // 新建时重置关联获客链接
        this.linkedCustomerAcquisition = []
        // 新建时重置异常浏览相关字段
        this.is_browsing = 1
        this.browsing_at = 8
        this.backup_novel_no = ''
        this.backup_novel_name = ''
      }
      // eslint-disable-next-line eqeqeq
      if (alltype == 2 || alltype == 3) {
        console.log('修改', item)
        this.editid = item.iqiyi_promotion_link_no
        // eslint-disable-next-line eqeqeq
        if (alltype == 3) {
          this.title = item.title + '-复用'
          this.ids = item.id
        } else {
          this.title = item.title
        }
        this.presentation_type = item.presentation_type
        if (this.presentation_type === 2) {
          this.novel_content = normalizeMiniProgramHtml(item.novel_content)
          this.novel_button_img = item.novel_button_img
          this.article_name = item.article_name
          // this.article_id = item.article_id
          this.background_color = item.background_color ? item.background_color : '#F7F7F7'
          this.button_display_time = item.button_display_time
        } else {
          this.novel_button_img = item.novel_button_img
          this.background_color = item.background_color ? item.background_color : '#F7F7F7'
          this.button_display_time = item.button_display_time
        }
        this.shield_type = item.shield_type
        // eslint-disable-next-line eqeqeq
        if (this.presentation_type == 4) {
          this.shield_type = 4
        // eslint-disable-next-line eqeqeq
        } else if (this.shield_type == 4) {
          this.shield_type = 1
        }
        if (this.presentation_type === 3) {
          this.official_novel_no = item.official_novel_no ? item.official_novel_no : ''
          this.official_novel_no_name = item.official_novel_no_name ? item.official_novel_no_name : ''
        }
        if (this.presentation_type === 4) {
          this.applet_article_id = item.applet_article_id ? String(item.applet_article_id) : ''
          this.applet_article_name = item.applet_article_name ? item.applet_article_name : ''
        }
        // eslint-disable-next-line eqeqeq
        if (this.shield_type == 3) {
          this.novel_content_a = item.novel_content_a == null ? '' : normalizeMiniProgramHtml(item.novel_content_a)
        }
        // eslint-disable-next-line eqeqeq
        if (this.shield_type == 4) {
          this.novel_content = item.novel_content == null ? '' : normalizeMiniProgramHtml(item.novel_content)
        }
        // eslint-disable-next-line eqeqeq
        if (this.shield_type == 1) {
          this.novel_no = item.novel_no
          this.novel_name = item.novel_name
        }
        this.advertising_source = item.advertising_source
        this.right_content = item.right_content
        this.display = item.display
        this.is_browsing = item.is_browsing != null ? item.is_browsing : 1
        this.browsing_at = item.browsing_at != null ? item.browsing_at : 8
        this.backup_novel_no = item.backup_novel_no ? item.backup_novel_no : ''
        this.backup_novel_name = item.backup_novel_name ? item.backup_novel_name : ''
        this.button_text = item.button_text
        this.button_introduction_text = item.button_introduction_text
        this.button_title_text = item.button_title_text
        this.name = item.corp_name
        this.form.corp_id = item.corp_id
        this.background_image = item.background_image == null ? '' : item.background_image
        this.pop_up_image = item.pop_up_image == null ? '' : item.pop_up_image
        this.guide_map = item.guide_map == null ? '' : item.guide_map
        const merged = item.employee.map((name, index) => ({
          name,
          employee_no: item.employee_nos[index]
        }))
        console.log('merged', merged)
        this.form.userids = merged
        this.wechatid = item.app_id
        this.wechatname = item.account_name
        this.activeName = item.msg_type
        this.send_number = item.send_number
        this.extend_seconds = item.extend_seconds
        this.$nextTick(() => {
          let arr = []
          if (item.shield_region.length !== 0) {
          // arr = JSON.parse(item.shield_region)
            arr = item.shield_region
            this.$refs.tree.setCheckedKeys(arr)
          }
          this.selectedNodes = arr
        })
        // eslint-disable-next-line eqeqeq
        if (item.ban_start_time == 0 && item.ban_end_time == 0) {
          this.timevalue = ['', ''] // 必须是数组，否则选不了
          console.log('没有值')
        } else {
          console.log('有值')
          this.timevalue = [this.formatSecondsToTime(item.ban_start_time),
            this.formatSecondsToTime(item.ban_end_time)] // 控件用 23:59
        }
        if (item.msg_type === 'text') {
          console.log('文本')
          this.obj.content = item.msg_data.text.content
        }
        if (item.msg_type === 'img') {
          console.log('图片')
          this.keyid = item.msg_data.img.media_id
          this.temporary = item.msg_data.img.url
        }
        if (item.msg_type === 'news') {
          console.log('图文链接', item.msg_data.news.articles)
          this.arr = []
          this.arr = item.msg_data.news.articles.map(item => {
            // item是数组中的每一个值
            return {
              id: Math.random(),
              description: item.description,
              title: item.title,
              // url: item.url,
              url: item.url == null ? '' : item.url,
              testsrc: item.picurl,
              showtips: false
              // switchvalue: item.mini_program,
              // app_ids: item.appid,
              // app_path: item.path,
              // moswitchvalue: item.appid == '' ? 1 : 2
            }
          })
          // this.active = this.arr[0].id
          this.indexinput = 0
        }
        if (item.msg_type === 'miniprogrampage') {
          this.formLabelAlign.name = item.msg_data.miniprogrampage.title
          this.programimg = item.msg_data.miniprogrampage.thumb_media_url
          this.formLabelAlign.sourceMaterialId = item.msg_data.miniprogrampage.thumb_media_id
          this.formLabelAlign.link = item.msg_data.miniprogrampage.pagepath
          console.log('小程序')
        }
        // 加载关联的获客链接
        if (item.related_promotion_links && Array.isArray(item.related_promotion_links)) {
          this.linkedCustomerAcquisition = item.related_promotion_links.map(link => ({
            id: link.id,
            title: link.title,
            iqiyi_promotion_link_no: link.iqiyi_promotion_link_no
          }))
        } else {
          this.linkedCustomerAcquisition = []
        }
      }
    },
    formatSecondsToTime(sec) {
      if (!sec && sec !== 0) return ''
      const hours = String(Math.floor(sec / 3600)).padStart(2, '0')
      const minutes = String(Math.floor((sec % 3600) / 60)).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    choose() {
      this.dialogVisible = true
    },
    callbackr(item) {
      this.form.userids = []
      this.dialogVisible = false
      this.name = item.corp_name
      this.form.corp_id = item.corp_id
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.form.corp_id, this.form.userids)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.form.userids = arr
      console.log(arr)
    },
    handleClose(index) {
      this.form.userids.splice(index, 1)
    },
    async sumbitr() {
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      if (this.presentation_type === 2) {
        if (this.novel_content === '') {
          this.$message.error('请输入小说内容')
          return
        }
        if (this.novel_button_img === '') {
          this.$message.error('请选择小说底部按钮图片')
          return
        }
        // if (this.article_id === '') {
        //   this.$message.error('请选择默认文章')
        //   return
        // }
      }
      if (this.presentation_type === 3) {
        if (this.official_novel_no === '') {
          this.$message.error('请选择官方阅读指定小说')
          return
        }
      }
      if (this.presentation_type === 4) {
        if (this.applet_article_id === '') {
          this.$message.error('请选择官方阅读指定文章')
          return
        }
      }
      // eslint-disable-next-line eqeqeq
      if (this.shield_type == 4) {
        if (this.novel_content === '') {
          this.$message.error('请输入B页面内容')
          return
        }
      }
      // if (this.send_text === '') {
      //   this.$message.error('请输入发送内容')
      //   return
      // }
      // if (this.button_text === '') {
      //   this.$message.error('请输入按钮文字')
      //   return
      // }
      // if (this.button_title_text === '') {
      //   this.$message.error('请输入按钮标题')
      //   return
      // }
      if (this.wechatid === null) {
        this.$message.error('请选择小程序')
        return
      }

      if (this.activeName === 'img') {
        if (this.temporary === null) {
          this.$message.error('请选择图片')
          return
        }
        this.msgData = {}
        this.msgData.img = {}
        this.msgData.img.media_id = this.keyid
        console.log(' this.msgData图片', this.msgData)
      }
      if (this.activeName === 'text') {
        if (this.obj.content === '') {
          this.$message.error('请输入文本内容')
          return
        }
        this.msgData = {}
        this.msgData.text = {}
        this.msgData.text.content = this.obj.content
        console.log('this.msgData文字', this.msgData)
      }
      if (this.activeName === 'news') {
        const bool = this.arr.every((item, index, array) => {
          return item.title !== ''
        })
        if (bool === false) {
          this.$message.error('请输入标题')
          return
        }
        for (let i = 0; i < this.arr.length; i++) {
          // eslint-disable-next-line eqeqeq
          if (this.arr[i].url == '') {
            this.$message.error('请输入链接')
            return
          }
        }
        const boolthree = this.arr.every((item, index, array) => {
          return item.description !== ''
        })
        if (boolthree === false) {
          this.$message.error('请输入描述')
          return
        }
        const boolfour = this.arr.every((item, index, array) => {
          return item.testsrc !== ''
        })
        if (boolfour === false) {
          this.$message.error('请上传图片')
          return
        }
        this.msgData = {}
        this.msgData.news = {}
        this.msgData.news.articles = []
        this.arrsw = []
        this.arrsw = this.arr.map(item => {
          // item是数组中的每一个值
          return {
            description: item.description,
            title: item.title,
            url: item.url,
            picurl: item.testsrc
            // appid: item.app_ids,
            // path: item.app_path
            // mini_program: item.switchvalue
          }
        })
        this.msgData.news.articles = this.arrsw
        console.log('this.msgData图文', this.msgData)
      }

      // eslint-disable-next-line eqeqeq
      if (this.activeName == 'miniprogrampage') {
        console.log('小程序')
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.name == '') {
          this.$message.error('请输入标题')
          return
        }
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.sourceMaterialId == null) {
          this.$message.error('请上传图片')
          return
        }
        // // eslint-disable-next-line eqeqeq
        // if (this.formLabelAlign.appid == null) {
        //   this.$message.error('请选择小程序类型')
        //   return
        // }
        // if (this.formLabelAlign.appid === 99) {
        //   if (this.formLabelAlign.appid_Link == '') {
        //     this.$message.error('请输入指定小程序id')
        //     return
        //   }
        // }
        // eslint-disable-next-line eqeqeq
        if (this.formLabelAlign.link == '') {
          this.$message.error('请输入跳转地址')
          return
        }
        this.msgData = {}
        this.msgData.miniprogrampage = {}
        this.msgData.miniprogrampage.title = this.formLabelAlign.name
        this.msgData.miniprogrampage.pagepath = this.formLabelAlign.link
        this.msgData.miniprogrampage.thumb_media_id = this.formLabelAlign.sourceMaterialId
        // if (this.formLabelAlign.appid === 99) {
        //   this.msgData.miniprogrampage.appid = this.formLabelAlign.appid_Link
        // } else {
        //   this.msgData.miniprogrampage.appid = this.formLabelAlign.appid
        // }
      }
      const shield_region = this.selectedNodes.length === 0 ? [] : this.selectedNodes
      console.log('shield_region:', shield_region)
      this.useridsall = []
      this.useridsall = this.form.userids.map(item => {
        return item.employee_no
      })
      if (this.presentation_type === 2) {
        this.ont = {}
        this.ont.novel_content = normalizeMiniProgramHtml(this.novel_content)
        this.ont.novel_button_img = this.novel_button_img
        // this.ont.article_id = this.article_id
        this.ont.background_color = this.background_color
        // this.ont.advertising_source = this.advertising_source
        this.ont.button_display_time = this.button_display_time
      } else {
        this.ont = {}
        this.ont.novel_button_img = this.novel_button_img
        this.ont.background_color = this.background_color
        this.ont.button_display_time = this.button_display_time
        // eslint-disable-next-line eqeqeq
        if (this.shield_type == 4) {
          this.ont.novel_content = normalizeMiniProgramHtml(this.novel_content)
        }
      }
      const idsobj = {}
      // eslint-disable-next-line eqeqeq
      if (this.alltype == 3) {
        idsobj.id = this.ids
      }
      console.log(this.timevalue)
      // eslint-disable-next-line eqeqeq
      if (this.alltype == 1 || this.alltype == 3) {
        const [start, end] = this.timevalue || []
        const data = await iqiyipromotionlinkcreate({
          employee_nos: this.useridsall,
          corp_id: this.form.corp_id,
          // send_text: this.send_text,
          title: this.title,
          app_id: this.wechatid,
          button_text: this.button_text,
          button_introduction_text: this.button_introduction_text,
          button_title_text: this.button_title_text,
          msg_type: this.activeName,
          msg_data: this.msgData,
          send_number: this.send_number,
          extend_seconds: this.extend_seconds,
          background_image: this.background_image,
          pop_up_image: this.pop_up_image,
          guide_map: this.guide_map,
          shield_region: shield_region,
          presentation_type: this.presentation_type,
          ...this.ont,
          right_content: this.right_content,
          display: this.display,
          advertising_source: this.advertising_source,
          shield_type: this.shield_type,
          novel_no: this.novel_no,
          novel_content_a: normalizeMiniProgramHtml(this.novel_content_a),
          ...idsobj,
          // // eslint-disable-next-line eqeqeq
          // ban_start_time: this.timevalue.length == 0 ? '00：00' : this.timevalue[0],
          // // eslint-disable-next-line eqeqeq
          // ban_end_time: this.timevalue.length == 0 ? '00：00' : this.timevalue[1]

          // 🚀 这里是关键（提交兜底值）
          ban_start_time: start || '00:00',
          ban_end_time: end || '00:00',
          related_promotion_links: this.linkedCustomerAcquisition,
          is_browsing: this.is_browsing,
          browsing_at: this.browsing_at,
          official_novel_no: this.official_novel_no,
          official_novel_no_name: this.official_novel_no_name,
          applet_article_id: this.applet_article_id,
          backup_novel_no: this.backup_novel_no,
          backup_novel_name: this.backup_novel_name
        })
        this.$message({
          type: 'success',
          message: '创建成功!'
        })
        console.log(data)
        this.$emit('updata')
      } else {
        const [start, end] = this.timevalue || []
        const data = await iqiyipromotionlinkedit({
          employee_nos: this.useridsall,
          corp_id: this.form.corp_id,
          // send_text: this.send_text,
          title: this.title,
          app_id: this.wechatid,
          button_text: this.button_text,
          button_introduction_text: this.button_introduction_text,
          button_title_text: this.button_title_text,
          msg_type: this.activeName,
          msg_data: this.msgData,
          send_number: this.send_number,
          extend_seconds: this.extend_seconds,
          iqiyi_promotion_link_no: this.editid,
          background_image: this.background_image,
          pop_up_image: this.pop_up_image,
          guide_map: this.guide_map,
          shield_region: shield_region,
          presentation_type: this.presentation_type,
          ...this.ont,
          right_content: this.right_content,
          display: this.display,
          advertising_source: this.advertising_source,
          shield_type: this.shield_type,
          novel_no: this.novel_no,
          novel_content_a: normalizeMiniProgramHtml(this.novel_content_a),
          // // eslint-disable-next-line eqeqeq
          // ban_start_time: this.timevalue.length == 0 ? '00：00' : this.timevalue[0],
          // // eslint-disable-next-line eqeqeq
          // ban_end_time: this.timevalue.length == 0 ? '00：00' : this.timevalue[1]
          // 🚀 这里是关键（提交兜底值）
          ban_start_time: start || '00:00',
          ban_end_time: end || '00:00',
          related_promotion_links: this.linkedCustomerAcquisition,
          is_browsing: this.is_browsing,
          browsing_at: this.browsing_at,
          official_novel_no: this.official_novel_no,
          official_novel_no_name: this.official_novel_no_name,
          applet_article_id: this.applet_article_id,
          backup_novel_no: this.backup_novel_no,
          backup_novel_name: this.backup_novel_name
        })
        this.$message({
          type: 'success',
          message: '修改成功!'
        })
        console.log(data)
        this.$emit('updata')
      }
    },
    // 获取光标所在位置的index
    handleInputBlur(e) {
      this.blurIndex = e.srcElement.selectionStart
    },
    tiaoInputBlur(e) {
      this.tiaoblurIndex = e.srcElement.selectionStart
    },
    // 选择标志回调
    addidentifit() {
      // if (this.obj.content.includes('{wx_url}') || this.obj.content.includes('{home_url}')) {
      //   this.$message.warning('已包含 {wx_url}或者{home_url}，无需重复添加')
      //   return
      // }
      this.obj.content = this.obj.content.slice(0, this.blurIndex) + this.addtifit + this.obj.content.slice(this.blurIndex)
    },
    addidentifitindex() {
      // if (this.obj.content.includes('{wx_url}') || this.obj.content.includes('{home_url}')) {
      //   this.$message.warning('已包含 {wx_url}或者{home_url}，无需重复添加')
      //   return
      // }
      this.obj.content = this.obj.content.slice(0, this.blurIndex) + this.addtifitindex + this.obj.content.slice(this.blurIndex)
    },
    // 选择标志回调
    addidentifittwo() {
      if (this.arr[this.indexinput].url.includes('{wx_url}') || this.arr[this.indexinput].url.includes('{home_url}')) {
        this.$message.warning('已包含 {wx_url}或者{home_url}，无需重复添加')
        return
      }
      this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + this.addtifit + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
    },
    addidentifittwoindex() {
      if (this.arr[this.indexinput].url.includes('{wx_url}') || this.arr[this.indexinput].url.includes('{home_url}')) {
        this.$message.warning('已包含 {wx_url}或者{home_url}，无需重复添加')
        return
      }
      this.arr[this.indexinput].url = this.arr[this.indexinput].url.slice(0, this.tiaoblurIndex) + this.addtifitindex + this.arr[this.indexinput].url.slice(this.tiaoblurIndex)
    },
    choosewecaht() {
      this.dialogVisiblewechat = true
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callback(item) {
      this.dialogVisiblewechat = false
      this.wechatname = item.account_name
      this.wechatid = item.app_id
      console.log('item', item)
    },
    materiallibrary() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      console.log(img, key)
      if (this.activeName === 'img') {
        this.temporary = img
        this.keyid = key
      }
      if (this.activeName === 'news') {
        this.arr[this.indexinput].testsrc = img
        // this.testsrc = img
      }
      if (this.activeName === 'miniprogrampage') {
        this.formLabelAlign.sourceMaterialId = key
        this.programimg = img
      }
      this.dialogVisibletwo = false
    },
    aweq(type) {
      this.xuantype = type
      this.dialogVisibletuww = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.TencentCloudChooseimgrview.parentHandleclick('1')
      }, 100)
    },
    clearImage(type) {
      this[type] = '' // 清空图片 URL
      if (type === 'pop_up_image') {
        this.showDefault = false // 如果要连默认图一起清掉
      }
      // 如果还有 guide_map、background_image 等，也可以在这里对它们做类似处理
    },
    chuantu(img) {
      this.dialogVisibletuww = false
      // eslint-disable-next-line eqeqeq
      if (this.xuantype == 'background_image') {
        this.background_image = img
      }
      // eslint-disable-next-line eqeqeq
      if (this.xuantype == 'pop_up_image') {
        this.pop_up_image = img
      }
      // eslint-disable-next-line eqeqeq
      if (this.xuantype == 'guide_map') {
        this.guide_map = img
      }
      // eslint-disable-next-line eqeqeq
      if (this.xuantype == 'novel_button_img') {
        this.novel_button_img = img
      }
    },
    async handleCheckChange(data, checked, indeterminate) {
      this.loadselect = true
      if (checked) {
        if (data.children) {
          this.selectedNodes.push(...data.children.map(e => e.label))
        } else {
          this.selectedNodes.push(data.label)
        }
        // 选中
      } else {
        console.log('indeterminate:', indeterminate, data)
        if (data.children && indeterminate !== true) {
          this.selectedNodes = this.selectedNodes.filter(child => !data.children.some(node => node.label === child))
        } else {
          this.selectedNodes = this.selectedNodes.filter(e => e !== data.label)
        }
        // 取消
      }
      this.selectedNodes = [...new Set(this.selectedNodes)]
    },
    chaweimg() {
      this.choicedialogVisibleimg = true
    },
    callbackimgs(item, type) {
      console.log('777777777777777777')
      this.choicedialogVisibleimg = false
      console.log(item, type)
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        console.log('进1')
        this.$refs.editorwangfour.send(item, 1)
        // eslint-disable-next-line eqeqeq
      } else if (type == 2) {
        console.log('进2')
        // console.log(this.encodeSearchKey(item.link))
        this.$refs.editorwangfour.send(item, 6)
      }
    },
    activewe() {
      this.dialogVisiblenotes = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chooseaciverview.send()
      }, 100)
    },
    chooseOfficialArticle() {
      // eslint-disable-next-line eqeqeq
      if (this.wechatid == '' || this.wechatid == null) {
        this.$message.error('请选择小程序')
        return
      }
      this.dialogVisiblenotes = true
      setTimeout(() => {
        this.$refs.chooseaciverview.send()
      }, 100)
    },
    wenzhang(item) {
      this.dialogVisiblenotes = false
      // eslint-disable-next-line eqeqeq
      if (this.presentation_type == 4) {
        this.applet_article_id = String(item.id)
        this.applet_article_name = item.name
      } else {
        this.article_id = item.id
        this.article_name = item.name
      }
    },
    cliwser() {
      this.article_id = ''
      this.article_name = ''
    },
    callbackerweima(item, type) {
      console.log(item, type)
      this.erweidialog = false
      this.$refs.editorwangfour.send({ id: 1, path: item.qr_code }, 1)
    },
    searchr() {
      this.erweidialog = true
      this.$nextTick(() => {
        this.$refs.erweimaview.send()
      })
    },
    choosenocelr(xiaoshuotype) {
      // eslint-disable-next-line eqeqeq
      if (this.wechatid == '' || this.wechatid == null) {
        this.$message.error('请选择小程序')
        return
      }
      this.xiaoshuotype = xiaoshuotype
      this.noveldialog = true
      this.$nextTick(() => {
        this.$refs.novellistdialogview.sendr(this.wechatid, this.xiaoshuotype)
      })
    },
    callnovel(item) {
      // eslint-disable-next-line eqeqeq
      if (this.xiaoshuotype == 1) {
        this.noveldialog = false
        this.novelChartdialog = false
        this.novel_no = item.novel_no
        this.novel_name = item.novel_name
      // eslint-disable-next-line eqeqeq
      } else if (this.xiaoshuotype == 3) {
        this.noveldialog = false
        this.novelChartdialog = false
        this.backup_novel_no = item.novel_no
        this.backup_novel_name = item.novel_name
      } else {
        this.noveldialog = false
        this.novelChartdialog = false
        this.official_novel_no = item.novel_no
        this.official_novel_no_name = item.novel_name
      }
      console.log(item)
    },
    onPresentationTypeChange(val) {
      // eslint-disable-next-line eqeqeq
      if (val == 4) {
        this.shield_type = 4
        this.nkawer(4)
      // eslint-disable-next-line eqeqeq
      } else if (this.shield_type == 4) {
        this.shield_type = 1
        this.nkawer(1)
      }
    },
    nkawer(val) {
      console.log(val)
      // eslint-disable-next-line eqeqeq
      if (val == 1) {
        this.novel_content_a = ''
        this.novel_content = ''
      // eslint-disable-next-line eqeqeq
      } else if (val == 2) {
        this.novel_no = ''
        this.novel_name = ''
        this.novel_content_a = ''
        this.novel_content = ''
      // eslint-disable-next-line eqeqeq
      } else if (val == 4) {
        this.novel_no = ''
        this.novel_name = ''
        this.novel_content_a = ''
      } else {
        this.novel_no = ''
        this.novel_name = ''
        this.novel_content = ''
      }
    },
    clearTime(val) {
      if (!val) {
        console.log('11111')
        this.timevalue = ['', ''] // 必须是数组，否则选不了
      }
    },
    onDialogClosed() {
    // ✅ 通知子组件清理定时器
      if (this.$refs.chhosewecahtr) {
        this.$refs.chhosewecahtr.clearTimer()
      }
    },
    // 打开关联获客链接弹窗
    openLinkDialog() {
      console.log('this.paid', this.paid)
      this.linkDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.linkCustomerAcquisitionView) {
          this.$refs.linkCustomerAcquisitionView.initSelected(this.linkedCustomerAcquisition, this.paid, this.wechatid)
        }
      })
    },
    // 确认选择关联获客链接
    confirmLinkSelection() {
      if (this.$refs.linkCustomerAcquisitionView) {
        this.linkedCustomerAcquisition = this.$refs.linkCustomerAcquisitionView.getSelectedItems()
        this.linkDialogVisible = false
      }
    },
    // 删除关联的获客链接
    handleRemoveLink(index) {
      this.linkedCustomerAcquisition.splice(index, 1)
    },
    // 关闭关联获客链接弹窗
    handleLinkDialogClose() {
      // 弹窗关闭时的处理
    },
    xuanhfive(target = 'news') {
      this.hfiveInsertTarget = target
      this.hfivedialog = true
      this.$nextTick(() => {
        this.$refs.hfiveview.send()
      })
    },
    hfiveviewcallback(item) {
      this.hfivedialog = false
      // 生成占位符：{h5_url_20}
      const placeholder = `{h5_url_${item.id}}`
      // 文本回复框：不限制次数，可重复插入
      if (this.hfiveInsertTarget === 'text') {
        const currentText = this.obj.content || ''
        const insertIndex = this.blurIndex == null ? currentText.length : this.blurIndex
        this.obj.content = currentText.slice(0, insertIndex) + placeholder + currentText.slice(insertIndex)
        return
      }

      // news 类型：选择后先清空，再填入占位符
      this.arr[this.indexinput].url = placeholder
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.task_box {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.updata_box {
  width: 708px;
  border: 1px solid #dddee1;
  padding: 10px;
  margin-bottom: 10px;
}
.pic_img {
  width: 100px;
  height: 100px;
  padding: 10px;
}
.pic_box {
  width: 238px;
  border: 1px solid #ccc;
  position: relative;
}
.writtenwords {
  /* padding: 20px; */
  white-space: pre-line;
}
.imaetext {
  display: flex;
  justify-content: space-between;
}
.imagetext {
  padding: 10px;
}
.newview {
  padding: 10px;
  max-height: 340px;
  overflow: hidden;
  overflow-y: auto;
}
.newview::-webkit-scrollbar {
  display: none;
}
.image_title {
  margin-bottom: 20px;
}
.tab_box {
  width: 880px;
  border: 1px solid #dddee1;
  padding: 5px 24px 52px 15px;
  margin-top: 20px;
}
.add_boxr {
  width: 708px;
  border: 1px dashed #999999;
  padding: 5px 0px;
  text-align: center;
  margin-top: 15px;
}
.examples_leftbox {
  width: 258px;
  height: 126px;
  border: 1px solid #dddee1;
  padding: 5px 10px;
  position: relative;
}
.examples_leftboxtelrp {
  width: 202px;
  height: 123px;
  border: 1px solid #dddee1;
  padding: 5px 10px;
  position: relative;
}
.addwr {
  position: absolute;
  bottom: -30px;
  left: 80px;
}
.within_box {
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
}
.se_top {
  margin-top: 14px;
}
.describe_text {
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.input_box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.allexamples_box {
  display: flex;
  margin-top: 20px;
}
.examples_rightbox {
  margin-left: 30px;
}
.cover_box {
  display: flex;
  align-items: center;
}
.choose_cover {
  margin-left: 10px;
  margin-right: 10px;
}
.cropper-content .cropper {
  width: auto;
  height: 300px;
}
.upload-demo /deep/ .el-upload-dragger {
  width: auto;
  height: auto;
  border: none;
}
.uopatatextimg {
  width: 100px;
  height: 100px;
  margin-top: 20px;
  object-fit: contain;
}
.choosecover {
  display: flex;
  align-items: center;
}
.text_wei {
  flex-shrink: 0;
}
.chooseitem {
  margin-bottom: 30px;
}
.save_box {
  margin-top: 10px;
}
.choose_textr {
  margin-top: 20px;
  display: flex;
  align-items: center;
}
.link_url {
  margin: 0 10px;
}
.btn_determine {
  margin-top: 30px;
  text-align: right;
}
.tips_mask {
  position: absolute;
  top: 0;
  opacity: 0.5;
  background: #000000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 55px;
  justify-content: space-around;
}
.tipicon {
  font-size: 19px;
  color: black;
}
.add_name {
  /* margin: 10px 0px 0px 0px; */
  margin-right: 10px;
}
.phone_box {
  background: url('https://mp.2f.com/v2.7.2/img/iphone6.395625b9.jpg') no-repeat;
  background-size: 100% 100%;
  width: 300px;
  height: 600px;
  margin-left: 100px;
  position: relative;
}
.phone_content {
  width: 224px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
  padding: 10px 25px 14px 11px;
  box-sizing: border-box;
}
.phone_contentone {
  width: 224px;
  background: #ffffff;
  position: absolute;
  top: 135px;
  left: 30px;
}
.phone_data {
  color: #d1dfff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.phone_item {
  margin-bottom: 10px;
}
.add_template {
  display: flex;
}
.choose_plate {
  display: flex;
  align-items: center;
}
.li_img {
  width: 100px;
  height: 100px;
}
.updataactive {
  border: 2px solid #07c160 !important;
}
.updatabox {
  height: 100px;
  width: 220px;
  text-align: center;
  line-height: 100px;
  border: 1px solid #f3f3f3;
  position: relative;
}
.updatabox1 {
  position: relative;
  height: 72px;
  width: 220px;
  border: 1px solid #f3f3f3;
  padding: 0 27px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.spanbox {
  position: absolute;
  left: 15px;
  top: 30px;
  z-index: 9;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 187px;
  text-align: left;
  height: 60px;
}
.spanbox1 {
  position: inherit;
  left: 0;
  top: 0;
  z-index: 9;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.backrbox {
  width: auto;
  height: 100%;
  background-color: #e1e1e1;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.backrbox1 {
  position: absolute;
  background-color: #e1e1e1;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  top: 9px;
  right: 17px;
  width: 50px;
  height: 50px;
}
.addbox {
  width: 220px;
  height: 48px;
  border: 1px solid #f3f3f3;
  text-align: center;
  line-height: 48px;
  position: relative;
}
.tipbox {
  position: absolute;
  background: white;
  padding: 10px;
  position: absolute;
  top: 39px;
  left: 180px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 20px;
  height: 20px;
}
.ciclebox {
  /* padding: 15px 7px 5px 7px; */
  margin: 0 7px;
  background-color: #fff;
  box-shadow: 0 1px 6px 0 #e4e8eb;
  border-radius: 25px;
  position: absolute;
  left: 220px;
  top: 50%;
  transform: translate(0, -50%);
}
.tiparrowbox {
  display: flex;
  flex-direction: column;
}
.title_box {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 187px;
}
.title_boxr {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 30px;
  width: 217px;
  overflow: hidden;
}
.chooser_allbox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 600px;
  overflow-y: auto;
}
.chooser_box {
  width: 250px;
  height: 430px;
  border: 1px solid #e9e9e9;
  padding: 12px;
  box-sizing: border-box;
  /* margin: 0 auto; */
  margin-bottom: 20px;
  margin-right: 30px;
}
.titlew_box {
  margin-left: 5px;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cahrw_box {
  margin-top: 10px;
}
.line {
  height: 1px;
  background-color: #e9e9e9;
  width: 100%;
  margin-top: 8px;
}
.daser {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 227px;
  margin-top: 5px;
  height: 37px;
}
.copy_box {
  display: flex;
  align-items: center;
}
.copy_icon {
  margin-left: 5px;
}
.Pchooser_allbox {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-height: 400px;
  overflow-y: auto;
}
.Pchooser_box {
  width: 100%;
  height: 75%;
  box-sizing: border-box;
  margin-right: 30px;
}
.Ptitlew_box {
  margin-left: 5px;
  /* width: 150px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.Pcahrw_box {
  /* margin-top: 10px; */
}
.Pline {
  height: 1px;
  background-color: #e9e9e9;
  width: 100%;
  margin-top: 8px;
}
.Pdaser {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* width: 227px; */
  margin-top: 5px;
  max-height: 35px;
  margin-bottom: 5px;
}
.Pdaserr {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
  margin-top: 5px;
  max-height: 35px;
  margin-bottom: 5px;
}
.Pcopy_box {
  display: flex;
  align-items: center;
}
.Pcopy_icon {
  margin-left: 5px;
}
.serwerwe {
  border: 1px solid #ccc;
  padding: 15px;
  margin-top: 10px;
}
.linkfw {
  max-height: 400px;
  overflow: auto;
}
.title-tips {
  font-size: 12px;
  position: absolute;
  top: 0;
  left: 320px;
}
.warning-title {
  color: red;
  font-size: 12px;
}
.phone {
  position: absolute;
  top: 7%;
  right: -1%;
}
/* 外层固定尺寸 = 原始 360×640 * 0.7 ≈ 252×448 */
.mobile-preview-wrapper {
  width: 252px;
  height: 448px;
  overflow: hidden;
  margin: 20px auto;
}

/* 内层缩放到 70% */
.phone-frame {
  width: 360px;
  height: 640px;
  transform: scale(0.5);
  transform-origin: top left;
}

/* 以下样式同上 */
.screen {
  border: 1px solid #ccc;
  border-radius: 20px;
  box-shadow: 0px 0px 10px #ccc;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  background-size: cover;
  background-position: center;
}
.pop-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 29%;
  z-index: 999;
  align-items: center;
}
.pop-bg {
  position: absolute;
  top: 120px;
  left: 33px;
  border-radius: 10px;
  width: 294px;
  overflow: hidden;
  height: 340px;
}
.pop-bg img {
}
.popup-title {
  width: 65%;
  text-align: center;
  font-size: 30px;
  margin-top: 50px;
  color: rgb(185 21 21);
}
.popup-description {
  margin-top: 50px;
  font-size: 20px;
}
.preview-button {
  margin-top: 90px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  padding: 15px 50px;
  border: 2px solid rgb(185 21 21);
  border-radius: 50px;
  color: rgb(185 21 21);
  font-size: 25px;
  animation: pulse 1.5s ease-in-out infinite;
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.btn-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
@media (max-width: 768px){
  .phone{
    position:relative;
    right: -12%;
    top:1%;

  }
  .warning-title{
    left:0vw;
    line-height:4vw;
    top:9vw;
    font-size:2.5vw;
  }
  .allexamples_box_top{
    position:relative;
  }
  .allexamples_box{
    flex-direction:column;
    overflow:auto;
  }
  .mobile-preview-wrapper{
    height: 85vw;
  }
}
</style>
